import { post, put, patch, del } from 'aws-amplify/api';
import { isCdkProxyConfigured } from '../lib/appConfig';
import { fetchCdkProxy } from '../lib/cdkProxy';
import { auditCallerHeaders } from './auditCallerHeaders';
import { readAmplifyJson } from './ntvaFlowProxy';

const METHODS = {
  POST: post,
  PUT: put,
  PATCH: patch,
  DELETE: del,
};

export function resolveProxyHubSpotId({
  hubSpotId,
  path,
  body,
  queryParams,
} = {}) {
  if (hubSpotId) return String(hubSpotId);
  if (queryParams?.portalId) return String(queryParams.portalId);
  if (queryParams?.hubSpotId) return String(queryParams.hubSpotId);
  if (body && typeof body === 'object') {
    if (body.portalId) return String(body.portalId);
    if (body.hubSpotId) return String(body.hubSpotId);
    if (body.clientId) return String(body.clientId);
  }
  const ntam = String(path || '').match(/dialer\/portals\/([^/]+)/i);
  if (ntam) return ntam[1];
  return '';
}

/**
 * Mutación autenticada para auditar quién.
 * Con `REACT_APP_NUA_PROXY_URL` va al CDK (`/{service}/{hubSpotId}/...`)
 * y el error se propaga. Si no, Amplify Gen 2 `/proxy/{service}/...`;
 * el caller puede caer al fetch directo si Amplify lanza.
 */
export async function proxyExternalMutation({
  service,
  path,
  method,
  body,
  queryParams,
  hubSpotId,
}) {
  if (isCdkProxyConfigured()) {
    return fetchCdkProxy({
      service,
      hubSpotId: resolveProxyHubSpotId({ hubSpotId, path, body, queryParams }),
      path,
      method,
      body,
      queryParams,
    });
  }

  const apiMethod = METHODS[String(method || '').toUpperCase()];
  if (!apiMethod) throw new Error(`Método no soportado: ${method}`);
  if (!service) throw new Error('Falta el servicio del proxy');

  const cleanPath = String(path || '').replace(/^\/+/, '');
  const options = {
    headers: {
      'Content-Type': 'application/json',
      ...(await auditCallerHeaders()),
    },
  };
  if (body !== undefined) options.body = body;
  if (queryParams) options.queryParams = queryParams;

  const { body: bodyResponse } = await apiMethod({
    apiName: 'nuatalker',
    path: `/proxy/${service}/${cleanPath}`,
    options,
  }).response;
  return await readAmplifyJson(bodyResponse);
}
